var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8048 11.1381C12.0651 10.8777 12.0651 10.4556 11.8048 10.1953C11.5444 9.93491 11.1223 9.93491 10.862 10.1953L7.52864 13.5286C7.26829 13.7889 7.26829 14.2111 7.52864 14.4714L10.862 17.8047C11.1223 18.0651 11.5444 18.0651 11.8048 17.8047C12.0651 17.5444 12.0651 17.1223 11.8048 16.8619L8.94285 14L11.8048 11.1381Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1381 10.1953C16.8778 9.93491 16.4557 9.93491 16.1953 10.1953C15.935 10.4556 15.935 10.8777 16.1953 11.1381L19.0572 14L16.1953 16.8619C15.935 17.1223 15.935 17.5444 16.1953 17.8047C16.4557 18.0651 16.8778 18.0651 17.1381 17.8047L20.4714 14.4714C20.7318 14.2111 20.7318 13.7889 20.4714 13.5286L17.1381 10.1953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuToggle);
export default __webpack_public_path__ + "static/media/MenuToggle.e403551f16da209f821d5783239981ea.svg";
export { ForwardRef as ReactComponent };